import { Component, OnInit } from "@angular/core";
import { TranslationLoadedService } from "../../services/translation-loaded.service";
import { TranslateService } from "@ngx-translate/core";
import { PerfilService } from "src/app/services/perfil.service";
import { AuthService } from "src/app/services/auth.service";

@Component({
  selector: "app-idioma",
  templateUrl: "./idioma.component.html",
  styleUrls: ["./idioma.component.scss"],
})
export class IdiomaComponent implements OnInit {
  private auth_key: string;
  private id: number;

  language = "";
  displayUserData: any;
  user: any;
  isSpanishSelected = false;
  isEnglishSelected = false;

  constructor(
    private _translationLoadedService: TranslationLoadedService,
    private translate: TranslateService,
    private perfilService: PerfilService,
    private authService: AuthService
  ) {
    this._translationLoadedService.defaultLanguage$.subscribe((lang) => {
      this.language = lang;
      this.translate.use(lang);
      this.language === "es" ? (this.isSpanishSelected = true) : (this.isEnglishSelected = true);
    });
    this.getDataUser();
  }

  ngOnInit() {
    this.getDataUser();
  } 

  toggleLanguage(lang: string, event) {
    if (lang === 'es') {
      this.isSpanishSelected = event.detail.checked;
      this.isEnglishSelected = !this.isSpanishSelected;  // Invertir el estado del otro toggle
    } else if (lang === 'en') {
      this.isEnglishSelected = event.detail.checked;
      this.isSpanishSelected = !this.isEnglishSelected;  // Invertir el estado del otro toggle
    }
    // Aquí puedes agregar la lógica para cambiar el idioma de tu aplicación
    this.language = this.isSpanishSelected ? 'es' : 'en';
    this._translationLoadedService.updateLanguaje(this.id,this.auth_key,this.language).subscribe(
      (response: any) => {
        // Verificar la respuesta del servidor
        console.log("Respuesta del servidor:", response);
      },
      (error) => {
        console.error("Error al enviar la solicitud:", error);
      }
      );
      this._translationLoadedService.changeLanguage(this.language);
  }

  getDataUser() {
    this.authService.userData$.subscribe((res: any) => {
      this.displayUserData = res;
      this.auth_key = this.displayUserData?.auth_key;
      this.id = this.displayUserData?.id;
      this.perfilService
        .get(this.id, this.auth_key)
        .subscribe((resPerfil: any) => {
          if (resPerfil) {
            this.user = resPerfil;
            console.log("Datos del usuario:", this.user);
          } else {
            console.log("Datos del perfil no disponibles.");
          }
        });
    });
  }
}
